module.exports = __webpack_public_path__ + "img/landing.a5644f92.jpg";